import React from 'react';
import Buttons from '../Common/Buttons';
import { useLocale } from '../../localization/LocaleContext';
import { useCurrency } from '../../localization/CurrencyContext';
import './FreelancersPage.css';

/* fa-circle-check */
const CircleCheckSvg = () => (
    <svg width="16" height="16" viewBox="0 0 512 512" fill="currentColor" style={{ flexShrink: 0 }}>
        <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/>
    </svg>
);

/* fa-file-invoice */
const FileInvoiceSvg = () => (
    <svg width="16" height="16" viewBox="0 0 384 512" fill="currentColor">
        <path d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm128 72c8.8 0 16 7.2 16 16v17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11.1 11.3 19.6s-11.1 13.6-19.6 11.3c-11.1-3-22-4.7-32.4-4.7c-11.3 0-18 2.8-20.3 4.5c-1.6 1.2-2.1 2.3-2.1 4.6c0 1.9 .8 3.3 2.6 4.6c3.6 2.6 9.6 4.6 18.4 6.6l.7 .1c15.2 3.4 34.3 7.6 47.7 18.3c8.4 6.7 13.7 16.5 13.7 28.6c0 15.7-8.9 28.2-21.4 35.4c-6.2 3.6-13.3 5.9-20.6 7.2V400c0 8.8-7.2 16-16 16s-16-7.2-16-16v-17.3c-9.6-1.4-18.9-3.6-27.2-6.1c-8.4-2.6-13.1-11.5-10.5-19.9s11.5-13.1 19.9-10.5c11.6 3.6 23.4 5.8 34.4 5.8c12.6 0 20.1-3.1 22.9-5.1c1.4-1 1.9-2 1.9-3.9c0-1.6-.6-2.9-2.2-4.1c-3.2-2.4-8.8-4.2-17.2-6.1l-.7-.1c-15.4-3.4-34.6-7.7-48.1-18.5c-8.6-6.9-14-16.9-14-29.1c0-15.4 8.5-27.7 20.6-34.9c6.1-3.6 13.1-5.9 20.4-7.2V232c0-8.8 7.2-16 16-16z"/>
    </svg>
);

function InvoiceMockup({ t, formatCurrency }) {
    return (
        <div className="freelancer-mockup-wrapper d-none d-lg-flex">
            <div className="freelancer-mockup-glow-1" />
            <div className="freelancer-mockup-glow-2" />
            <div className="freelancer-invoice-mockup">
                <div className="freelancer-invoice-header">
                    <div>
                        <div className="freelancer-invoice-logo">
                            <FileInvoiceSvg />
                        </div>
                        <div className="freelancer-invoice-title-text" style={{ textAlign: 'left' }}>INVOICE</div>
                        <div className="freelancer-invoice-number" style={{ textAlign: 'left' }}>#INV-2026-001</div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                        <div className="freelancer-invoice-label">Due Date</div>
                        <div className="freelancer-invoice-name">Oct 15, 2026</div>
                    </div>
                </div>
                <div className="freelancer-invoice-parties">
                    <div>
                        <div className="freelancer-invoice-label">{t('freelancers.invoiceFrom')}</div>
                        <div className="freelancer-invoice-name">{t('freelancers.invoiceSender')}</div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                        <div className="freelancer-invoice-label">{t('freelancers.invoiceTo')}</div>
                        <div className="freelancer-invoice-name">{t('freelancers.invoiceRecipient')}</div>
                    </div>
                </div>
                <div className="freelancer-invoice-table">
                    <div className="freelancer-invoice-table-row">
                        <span>{t('freelancers.invoiceItem1')}</span>
                        <span>{formatCurrency(t('freelancers.invoiceItem1Price'))}</span>
                    </div>
                    <div className="freelancer-invoice-table-row">
                        <span>{t('freelancers.invoiceItem2')}</span>
                        <span>{formatCurrency(t('freelancers.invoiceItem2Price'))}</span>
                    </div>
                </div>
                <div className="freelancer-invoice-total-row">
                    <span className="freelancer-invoice-total-label">Total</span>
                    <span className="freelancer-invoice-total-value">{formatCurrency(t('freelancers.invoiceTotal'))}</span>
                </div>
                <div className="freelancer-invoice-status">
                    <svg width="12" height="12" viewBox="0 0 448 512" fill="currentColor" style={{ marginRight: 4, verticalAlign: 'middle' }}>
                        <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                    </svg>
                    {t('freelancers.invoiceStatus')}
                </div>
            </div>
        </div>
    );
}

function Banner(){
    const { t } = useLocale();
    const { formatCurrency } = useCurrency();

    return(
        <section className="freelancer-hero sp-60">
            <div className="container">
                <div className="row flex-column-reverse flex-lg-row align-items-center">
                    <div className="col-lg-6">
                        <h1 className="h-1 h-bold freelancer-hero-title">
                            {t('freelancers.bannerTitleStart')}{' '}
                            <span className="freelancer-hero-highlight">{t('freelancers.bannerTitleHighlight')}</span>
                        </h1>
                        <p className="freelancer-hero-description">
                            {t('freelancers.bannerSubtitle')}
                        </p>
                        <Buttons />
                        <div className="freelancer-hero-ticks">
                            <div className="tick-item">
                                <CircleCheckSvg />
                                <span>{t('ticks.freeTrial')}</span>
                            </div>
                            <div className="tick-item">
                                <CircleCheckSvg />
                                <span>{t('ticks.cancelAnytime')}</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 mb-4 mb-lg-0">
                        <InvoiceMockup t={t} formatCurrency={formatCurrency} />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Banner;